module.exports = __webpack_public_path__ + "img/职位.70527533.png";